import React from 'react';
import styled from 'styled-components';

import {Body} from 'web-app/react/components/text/text';

export const getPostTypeLabel = (label: string) => <StyledPostTypeLabel>{label}</StyledPostTypeLabel>;

export const StyledPostTypeLabel = styled(Body)`
    padding: 0 20px;
    border-right: #e6e6e6 1px solid;
`;
